module.exports = __webpack_public_path__ + "static/media/bin.bbb5a10e.png";